import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useTelegram() {
  const tg = (window as any).Telegram?.WebApp;
  const navigate = useNavigate();
  const location = useLocation();

  const onClose = () => {
    tg?.close();
  };

  useEffect(() => {
    if (!tg?.initDataUnsafe?.user) return;

    tg.MainButton.hide();

    const isNotMainPage = window.location.search || location.pathname !== '/';

    if (isNotMainPage) {
      tg.BackButton.show();

      const handleBack = () => {
        // Лучше задать конкретный маршрут, если navigate(-1) ведет не туда
        navigate(-1); // Или navigate('/some-page');
      };

      tg.BackButton.onClick(handleBack);

      return () => {
        tg.BackButton.offClick(handleBack);
      };
    } else {
      tg.BackButton.hide();
    }
  }, [tg, navigate, location]);

  return {
    onClose,
    tg,
    initData: tg?.initDataUnsafe,
  };
}
